import "normalize.css/normalize.css"; // a modern alternative to CSS resets
import "vant/lib/index.css";
import "amfe-flexible";
import "@/assets/styles/style.less";

import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import Vant from "vant";
import Clipboard from 'v-clipboard';

Vue.use(Vant);
Vue.use(Clipboard);

import WeixinEmojis from "vue-weixin-emojis";
import "vue-weixin-emojis/dist/vue-weixin-emojis.css";
Vue.use(WeixinEmojis, { url: "https://wechat.kopen.com.cn/storage/manage/images/202404/15/sJTFGMl7h45F7r6DaG1hhBUhESetHcRGFi4UGP1Q.png" });

Vue.config.productionTip = false;



new Vue({
	router,
	store,
	render: (h) => h(App),
}).$mount("#app");
